'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { useEffect } from 'react';

import type { ReservationStepProps } from '../reservation-form';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlDescription } from '../../ui/html-description';
import { PhoneIcon } from '../../icons/phone-icon';

export function ChoosePerson({ form, people }: ReservationStepProps) {
  const selectedPersonId = form.watch('reservation_person');

  useEffect(() => {
    if (!selectedPersonId && people?.length) {
      form.setValue('reservation_person', String(people[0].id));
    }
  }, [selectedPersonId, people, form]);

  return (
    <div className="grid w-full grid-cols-2 gap-2 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-6">
      {people?.map(person => {
        const isSelected = String(person.id) === String(selectedPersonId);

        return (
          <div
            key={person.id}
            onClick={() => form.setValue('reservation_person', String(person.id))}
            className={cn(
              'relative col-span-1 flex h-[210px] w-full items-end justify-start overflow-hidden rounded-[24px] p-4 sm:h-[420px] sm:p-5 lg:p-6 xl:h-[462px]',
              isSelected ? 'border-2 border-primary/50' : 'border-2 border-transparent',
              'cursor-pointer transition-all duration-200',
            )}
          >
            <Image
              src={`/images/${isSelected ? 'selected' : 'unselected'}-person.svg`}
              alt={person.name}
              width={0}
              height={0}
              className="absolute right-4 top-4 z-10 h-6 w-6 sm:right-5 sm:top-5 sm:h-8 lg:right-6 lg:top-6 lg:w-8"
            />
            <div className="flex flex-col gap-1">
              <p className="relative z-10 text-base font-semibold tracking-tight text-white sm:text-lg md:text-xl lg:text-2xl xl:text-3xl">
                {person.name.split(' ').map((part, idx) => (
                  <span key={`${part}-${idx}`}>
                    {idx > 0 ? <br /> : null}
                    {part}
                  </span>
                ))}
              </p>
              <p className="relative z-10 flex gap-1 text-sm font-semibold tracking-tight text-white sm:text-base">
                <PhoneIcon className="h-[14px] w-[14px] sm:h-[20px] sm:w-[20px]" /> {person.phone}
              </p>
              <HtmlDescription
                content={person.description}
                className="relative z-10 text-base font-medium tracking-tight text-white sm:text-lg md:text-xl lg:text-2xl xl:text-3xl"
              />
              <div
                className={cn(
                  'absolute inset-0 z-[1] h-full w-full',
                  'ea-member-card__image-overlay',
                )}
              />
            </div>

            <Image
              src={person?.image?.url || '/images/placeholder.png'}
              alt={resolveImageAlt(person?.image, person?.name)}
              width={0}
              height={0}
              className="absolute inset-0 z-0 h-full w-full object-cover object-center"
              sizes="100vw"
            />
          </div>
        );
      })}
    </div>
  );
}
